import { DataFilter } from '@siclop/kstone-vue'

export class TeamFilter extends DataFilter {
  code?: string
  label?: string

  constructor(data?: Partial<TeamFilter>) {
    super(data)
    if (data) {
      this.code = data.code
      this.label = data.label
    }
  }
}
